// extracted by mini-css-extract-plugin
export default {"main":"UseFulBlocks_main__Y3N1i","main_media":"UseFulBlocks_main_media__bCKMD","blog_menu":"UseFulBlocks_blog_menu__9u--S"};